/* Temporary mixin to reactify /transactions routing */
/* Will be removed during full transactions reactification (in process) */
module.exports = Em.Mixin.create({
    subscriptionLimits: Ember.inject.service(),
    customEvent: Ember.inject.service(),

    _customActionsTransactions: {
        addTransaction: function() {
            var self = this

            self.get('subscriptionLimits').checkForExpenseLimitAndExecute(function() {
                self.container.lookup('component:transaction-window').show()
            })
        }
    }
})
